<div class="columns is-centered m-0">
  <div class="column is-10 my-4">
    <app-error-notification classes="p-3 has-text-black">
      <p class="is-inline">
        An unexpected error occurred while submitting the consultation request. Please contact customer service at
        {{ contactEmail }} to learn about the next steps to follow. We apologize for the inconvenience and will work to
        resolve this issue promptly.
      </p>
    </app-error-notification>
  </div>
</div>
